"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsReceivalPreferenceQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var Types_1 = require("../Types");
var core_1 = require("@athena-portal/core");
var DocumentsReceivalPreferenceQuestionWidget = /** @class */ (function (_super) {
    __extends(DocumentsReceivalPreferenceQuestionWidget, _super);
    function DocumentsReceivalPreferenceQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps, prevState) {
            var interactionSendByPostText = _this.props.interaction.policyHolder.sendDocumentsByPost;
            var interactionSendByEmail = _this.props.interaction.policyHolder.sendDocumentsByEmail;
            if (prevState.sendByPostText !== interactionSendByPostText && prevState.sendByEmail !== interactionSendByEmail) {
                _this.setState({
                    sendByPostText: interactionSendByPostText,
                    sendByEmail: interactionSendByEmail
                });
            }
        };
        _this.renderValidationError = function () {
            var bottomText = _this.getErrorMessage();
            if (bottomText) {
                if (!_this.props.interaction.policyHolder.sendDocumentsByEmail && !_this.props.interaction.policyHolder.sendDocumentsByPost) {
                    return _this.focusAndDisplayErrorMessage(bottomText);
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        };
        _this.focusAndDisplayErrorMessage = function (errorMessage) {
            var elementToFocusOnAfterValidationFailure = document.getElementById('sendMyCoverDocuments');
            if (elementToFocusOnAfterValidationFailure) {
                elementToFocusOnAfterValidationFailure.focus();
            }
            return ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block mb-3", id: "bottomValidationMessage", children: errorMessage }));
        };
        _this.setSendingByEmail = function () {
            _this.setState({
                sendByEmail: true,
                sendByPostText: false
            });
            _this.props.onStateChange("policyHolder.sendDocumentsByEmail", true);
            _this.props.onStateChange("policyHolder.sendDocumentsByPost", false);
            _this.changelogRecorder.record(_this.props.engine.getInteraction(), "change", "policyHolder.sendDocumentsByEmail", _this.props.page && _this.props.page.pageId);
        };
        _this.setSendingByPost = function () {
            _this.setState({
                sendByEmail: false,
                sendByPostText: true
            });
            _this.props.onStateChange("policyHolder.sendDocumentsByEmail", false);
            _this.props.onStateChange("policyHolder.sendDocumentsByPost", true);
            _this.changelogRecorder.record(_this.props.engine.getInteraction(), "change", "policyHolder.sendDocumentsByPost", _this.props.page && _this.props.page.pageId);
        };
        _this.renderDocumentSendingText = function () {
            if (_this.state.sendByPostText) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "green-card inner-content", children: (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { className: "green-card-document", alt: "document", src: "/img/Policy-Documents-recycle-white.png" }), (0, jsx_runtime_1.jsx)("h2", { children: "Want printed documents?" }), (0, jsx_runtime_1.jsx)("br", {}), "No Problem - we can send them by post for the first month, and they will be dispatched within 7 working days. After that your documents will be available to view and download at any time by clicking on Your documents on Your account page. If you would still like to receive your documents by post, then email our customer service team at", (0, jsx_runtime_1.jsx)("a", { className: "no-underline text-white", href: "mailto:customerrelations_flow@lv.co.uk", target: "_blank", id: "customerSupport", children: " customerrelations_flow@lv.co.uk" }), " to request them."] }) }));
            }
            else if (_this.state.sendByEmail) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "green-card inner-content", children: (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { className: "green-card-document", alt: "document", src: "/img/Policy-Documents-recycle-white.png" }), (0, jsx_runtime_1.jsx)("h2", { children: "Thank you !" }), (0, jsx_runtime_1.jsx)("br", {}), "Thanks for helping us do our part for the environment by going paper-free. You can view or download your documents any time by clicking \u2018Documents\u2019 in your online account."] }) }));
            }
            else {
                return ((0, jsx_runtime_1.jsx)("div", { className: "green-card inner-content", children: (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { className: "green-card-document", alt: "document", src: "/img/Policy-Documents-recycle-white.png" }), (0, jsx_runtime_1.jsx)("h2", { children: "Did you know?" }), (0, jsx_runtime_1.jsx)("br", {}), "Did you know you can help the planet and receive all your policy documents online?"] }) }));
            }
        };
        _this.renderUI = function (renderValidationError, renderErrorCssClass) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "muli-bold-18", tabIndex: -1, id: "sendMyCoverDocuments", children: "Receive my cover documents" }), (0, jsx_runtime_1.jsxs)("div", { className: "checkBox", role: "group", "aria-label": "Send my cover documents by", children: [(0, jsx_runtime_1.jsxs)("label", { onClick: _this.setSendingByEmail, children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", name: "sendByEmail", id: "sendByEmail", "aria-label": "1 of 2 email", checked: _this.state.sendByEmail }), (0, jsx_runtime_1.jsxs)("div", { className: "checkbox ".concat(renderErrorCssClass ? "red-borders-after-validation-failure" : ""), children: [(0, jsx_runtime_1.jsx)("span", { className: "icon email-icon" }), (0, jsx_runtime_1.jsx)("span", { className: "text", children: "Online" })] })] }), (0, jsx_runtime_1.jsxs)("label", { onClick: _this.setSendingByPost, children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", name: "sendByPost", id: "sendByPost", "aria-label": "2 of 2 post", checked: _this.state.sendByPostText }), (0, jsx_runtime_1.jsxs)("div", { className: "checkbox ".concat(renderErrorCssClass ? "red-borders-after-validation-failure" : ""), children: [(0, jsx_runtime_1.jsx)("span", { className: "icon post-icon" }), (0, jsx_runtime_1.jsx)("span", { className: "text", children: "By Post" })] })] })] }), renderValidationError && _this.renderValidationError()] }), _this.renderDocumentSendingText()] }));
        };
        _this.questionName = _this.getSetting("questionName", "");
        _this.state = {
            sendByEmail: false,
            sendByPostText: false
        };
        return _this;
    }
    DocumentsReceivalPreferenceQuestionWidget.prototype.componentDidMount = function () {
        var policyHolder = this.props.interaction.policyHolder;
        if (!policyHolder.sendDocumentsByEmail && !policyHolder.sendDocumentsByPost) {
            this.setState({
                sendByPostText: false,
                sendByEmail: true
            });
            this.props.onStateChange("policyHolder.sendDocumentsByEmail", true);
            this.props.onStateChange("policyHolder.sendDocumentsByPost", false);
        }
        if (policyHolder.sendDocumentsByEmail) {
            this.setState({
                sendByPostText: false,
                sendByEmail: true
            });
        }
        if (policyHolder.sendDocumentsByPost) {
            this.setState({
                sendByPostText: true,
                sendByEmail: false
            });
        }
    };
    DocumentsReceivalPreferenceQuestionWidget.prototype.render = function () {
        if (this.renderValidationError()) {
            return this.renderUI(true, true);
        }
        else {
            return this.renderUI(false, false);
        }
    };
    DocumentsReceivalPreferenceQuestionWidget.prototype.getErrorMessage = function () {
        if (this.props.validations) {
            for (var _i = 0, _a = Object.keys(this.props.validations); _i < _a.length; _i++) {
                var questionName = _a[_i];
                var validationResult = this.props.validations[questionName];
                if (questionName === this.questionName && (validationResult.errors && validationResult.errors.length > 0)) {
                    return this.getSetting("bottomText") || "Please answer this to carry on";
                }
            }
        }
        return null;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], DocumentsReceivalPreferenceQuestionWidget.prototype, "changelogRecorder", void 0);
    return DocumentsReceivalPreferenceQuestionWidget;
}(plugin_journey_1.WidgetBase));
exports.DocumentsReceivalPreferenceQuestionWidget = DocumentsReceivalPreferenceQuestionWidget;
//# sourceMappingURL=DocumentsReceivalPreferenceQuestionWidget.js.map